import { useGetSavedSearch } from "@apis/explore";
import { VDBText } from "@components/atoms";
import Loader from "@components/atoms/Loader";
import FooterSpace from "@components/common/FooterSpace";
import useHideNavsOnScroll from "@navigations/utils/useHideNavsOnScroll";
import { savedSearches } from "@src/types/ExploreResult";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Animated from "react-native-reanimated";
import styled from "styled-components/native";
import ItemCardView from "./ItemCard/ItemCardView";
import { ProductTypeProps } from "./types";
import { convertProductType } from "./utils/convertProductType";
import { SpaceType } from "@components/atoms/Spacer/types";
import { Dimensions } from "react-native";
import {
  NavigationProp,
  useIsFocused,
  useNavigation,
} from "@react-navigation/native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { ProductCategory, ProductTypeCommon } from "@utils/constants";
import { useSearchFiltersSlice } from "@redux/slices/searchFilters";
import { filterSearchFilters } from "@scenes/explore/utils";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { ProtectedRoute } from "@navigations/utils/ProtectedRoute";

const SavedSearch = ({ index }: ProductTypeProps) => {
  const { t } = useTranslation();
  const { getPriceMode, getUserId } = useUserInfo();
  const isFocused = useIsFocused();
  const { theme, typography } = useScreenOptionsHooks();
  const userInfo = useUserInfo();

  const screenHeight =
    Dimensions.get("window").height -
    (userInfo.isBusinessPlan() || userInfo.isProPlan() ? 300 : 0);
  const [unifiedCollectionList, setUnifiedCollectionList] = useState<
    savedSearches[] | undefined
  >([]);
  const { filters } = useSearchFiltersSlice();
  let jewelryFilters = filterSearchFilters(
    filters?.[ProductCategory.JEWELRY],
    getPriceMode()
  );
  const navigation = useNavigation<NavigationProp<any>>();
  const getSavedSearchResult = useGetSavedSearch("Mix", getUserId());
  const { scrollHandler } = useHideNavsOnScroll();

  const onScrollHandler = scrollHandler();
  const onScroll = isFocused ? onScrollHandler : undefined;

  useEffect(() => {
    theme.isLargeScreen &&
      navigation.setOptions({
        title: t("savedSearch.title.text"),
      });
  }, []);

  useEffect(() => {
    const getSavedSearchData = getSavedSearchResult.data;

    if (getSavedSearchData?.data.message != null) {
      if (getSavedSearchData?.data.saved_searches) {
        const data = getSavedSearchData.data;
        const order = [1, 4, 2, 3];

        setUnifiedCollectionList(
          convertProductType(data.saved_searches, t, jewelryFilters)?.sort(
            (a, b) => {
              const aIsLabGrownJewelry =
                a.type === 3 &&
                a.search_options?.sub_type ===
                  ProductTypeCommon.LABGROWN_JEWELRY_SUB_TYPE;
              const bIsLabGrownJewelry =
                b.type === 3 &&
                b.search_options?.sub_type ===
                  ProductTypeCommon.LABGROWN_JEWELRY_SUB_TYPE;

              if (aIsLabGrownJewelry && !bIsLabGrownJewelry) return 1;
              if (!aIsLabGrownJewelry && bIsLabGrownJewelry) return -1;

              return order.indexOf(a.type) - order.indexOf(b.type);
            }
          )
        );
      }
    }
  }, [getSavedSearchResult?.data]);

  useEffect(() => {
    if (index === 1) {
      getSavedSearchResult.refetch();
    }
  }, [index === 1]);

  const renderFooter = () => {
    return <FooterSpace isLoader={false} backgroundColor={"core-02"} />;
  };

  const RenderFlatList = () => (
    <Animated.FlatList
      data={unifiedCollectionList}
      renderItem={({ item }) => <ItemCardView item={item} />}
      keyExtractor={(item) => item?.id.toString()}
      ListFooterComponent={renderFooter}
      onScroll={onScroll}
      contentContainerStyle={{
        paddingBottom: 20,
        paddingTop: SpaceType.Double,
      }}
      bounces={false}
      ListEmptyComponent={
        getSavedSearchResult?.isFetching ? (
          <CenterTextView height={screenHeight}>
            <Loader />
          </CenterTextView>
        ) : (
          <CenterTextView height={screenHeight}>
            <VDBText>{t("savedSearch.emptyData.text")}</VDBText>
          </CenterTextView>
        )
      }
    />
  );

  return (
    <ProtectedRoute disabled={index === 0}>
      <OverLay theme={theme}>
        {theme.isLargeScreen ? (
          <ScrollContainer>
            <SplitView>
              <TitleContainer>
                <VDBText type={typography["Lead-M"]} color={theme["core-05"]}>
                  {t("savedSearch.title.text")}
                </VDBText>
              </TitleContainer>
              <FlatListContainer>
                <RenderFlatList />
              </FlatListContainer>
            </SplitView>
          </ScrollContainer>
        ) : (
          <RenderFlatList />
        )}
      </OverLay>
    </ProtectedRoute>
  );
};

const OverLay = styled.View<any>`
  flex: 1;
  padding: ${({ theme }) => (theme.isMobile ? 0 : SpaceType.Big)}px;
  background-color: ${({ theme }) => theme["core-02"]};
  width: 100%;
`;

const CenterTextView = styled.View<{
  height?: number;
}>`
  flex: 1;
  justify-content: center;
  align-items: center;
  height: ${({ height = 1 }) => height * 0.6}px;
`;

const SplitView = styled.View`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const TitleContainer = styled.View`
  width: 30%;
`;

const ScrollContainer = styled.ScrollView``;

const FlatListContainer = styled.View`
  width: 70%;
`;

export default SavedSearch;
